export default __webpack_public_path__ + "static/media/travel-LP.61de6ebd.svg";